export class DataTableResponseModel {
    data: any[];
    draw: number;
    recordsFiltered: number;
    recordsTotal: number;
}
